import React, { useState } from "react";
import Image from "next/image";

import RightSymbol from "@/src/svg/right-symbol";
import LineArrowTwo from "@/src/svg/line-arrow-2";
import { useWindowSize } from "@react-hook/window-size";

import VideoPopup from "@/src/modals/video-popup";
import LineArrow from "@/src/svg/blue-underline";

interface AboutAreaProps {
    id: number;
    type: "image_first" | "image_last";
    title: {
        primary: string;
        secondary: string;
    };
    description: string;
    items: string[];
    image: any;
    videoData: any[];
}

const AboutArea = (props: AboutAreaProps) => {
    const { id, type, title, description, items, image, videoData } = props;

    const [windowWidth, windowHeight] = useWindowSize();
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const [selectedVideoId, setSelectedVideoId] = useState("");

    const gallery = () => {
        return (
            <div className="col-lg-6">
                <div
                    className={`${
                        type === "image_last" && "ml-65"
                    }  tp-about-3-img p-relative fadeLeft`}
                >
                    <Image
                        src={image}
                        alt="theme-pure p-relative"
                        height={500}
                    />
                </div>
            </div>
        );
    };

    const playVideo = (url: string) => {
        const regExp =
            /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/;
        const match = url.match(regExp);
        setSelectedVideoId(match ? match[1] : "");
        setIsVideoOpen(true);
    };

    const makeBold = (str: string, highlight: string) => {
        return str.replace(
            new RegExp(`(${highlight})`, "g"),
            '<span style="color: #0066E2;">$1</span>'
        );
    };

    const videoDataContainer = (index: number, videoData: any) => {
        return (
            <div
                className={`comprehensive-speed-wrapper ${
                    videoData.length > 1 ? "" : "container"
                }`}
            >
                <div
                    className="comprehensive-speed-content platform-videos-area__block-content"
                    style={{
                        flexDirection:
                            videoData.length > 1
                                ? "column-reverse"
                                : type === "image_last"
                                ? "row"
                                : "row-reverse",
                        gap: videoData.length > 1 ? 50 : undefined,
                    }}
                >
                    <div className="p-relative comprehensive-speed-image-wrapper">
                        <Image
                            src={videoData[index].image}
                            alt={"comprehensive-speed"}
                            className="platform-videos-area__block-image"
                        />
                        <div className="video-play">
                            <a
                                className="popup-video"
                                onClick={() =>
                                    playVideo(videoData[index].videoLink)
                                }
                            >
                                <i className="fa-sharp fa-solid fa-play" />
                            </a>
                        </div>
                    </div>
                    <div>
                        <div
                            className="tp-about-3-wrapper"
                            style={{
                                textAlign:
                                    videoData.length > 1 ? "center" : undefined,
                            }}
                        >
                            <span className="tp-section-title__pre platform-videos-area__block-subtitle">
                                {videoData[index].title}
                            </span>
                            <p className="tp-section-title partners platform-videos-area__block-title">
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: makeBold(
                                            videoData[index].description,
                                            videoData[index].highlight
                                        ),
                                    }}
                                />
                                {videoData[index].id === 2 ? (
                                    <span className="platform-videos-area__block-svg2">
                                        <LineArrow />
                                    </span>
                                ) : videoData[index].id === 3 ? (
                                    <span className="platform-videos-area__block-svg3">
                                        <LineArrow />
                                    </span>
                                ) : (
                                    <span className="platform-videos-area__block-svg">
                                        <LineArrow />
                                    </span>
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <section className="platform-area tp-about-3-area p-relative">
                <div className="container">
                    <div className="row">
                        {type === "image_first" &&
                            windowWidth > 575 &&
                            gallery()}
                        <div className="col-lg-6 mt-70">
                            <div className="tp-about-3-wrapper">
                                <div className="tp-about-3-title-wrapper">
                                    <h3 className="tp-section-title">
                                        <span
                                            className={
                                                id === 2 || id === 1
                                                    ? "title-color"
                                                    : ""
                                            }
                                        >
                                            {title.primary}
                                        </span>{" "}
                                        <span
                                            className={
                                                id === 3 || id === 4
                                                    ? "title-color"
                                                    : ""
                                            }
                                        >
                                            {title.secondary}
                                        </span>
                                        <span className="title-left-shape">
                                            <LineArrowTwo />
                                        </span>
                                    </h3>
                                </div>
                                <p className="platform__list-description mb-50">
                                    {description}
                                </p>
                                <div>
                                    {items.map((item, index) => (
                                        <div
                                            key={index}
                                            className="platform__list-item mb-30"
                                        >
                                            <div>
                                                <RightSymbol />
                                            </div>
                                            <span className="ml-20">
                                                {item}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {type === "image_last" &&
                            windowWidth > 575 &&
                            gallery()}
                    </div>
                </div>
                <section
                    className="comprehensive-speed p-relative"
                    style={{
                        backgroundImage: `url(/assets/img/platform/video-bg.svg)`,
                        backgroundSize: "cover",
                        display:
                            windowWidth > 575
                                ? videoData.length > 1
                                    ? "flex"
                                    : "block"
                                : "block",
                        justifyContent: "center",
                        gap: videoData.length > 1 ? 150 : 0,
                    }}
                >
                    {videoDataContainer(0, videoData)}
                    {videoData.length > 1 && videoDataContainer(1, videoData)}
                </section>
            </section>
            <VideoPopup
                isVideoOpen={isVideoOpen}
                setIsVideoOpen={setIsVideoOpen}
                videoId={selectedVideoId}
            />
        </>
    );
};

export default AboutArea;
